export const homepageValues = ['ads-free',
// Ads, for all hubs, I think
'buyerIntent-beta', 'calls', 'companies', 'contacts', 'content-agent', 'customer-agent', 'customerSuccess', 'customerSuccess-beta', 'dashboards', 'enrichment-beta',
// Data enrichment
'data-quality', 'deals', 'design-manager', 'email', 'content-embed',
// Embeds
'help-desk', 'website-database',
// HubDB
'inbox', 'lists', 'memberships', 'commerce-home',
// Commerce > Overview
'breeze-overview',
// Breeze > Overview
'contentRemix-beta', 'sms', 'sales',
// Sales workspace
'sequences', 'social', 'social-agent', 'tasks', 'tickets', 'pages', 'pages-beta',
// Website pages
'workflows'
// custom objects, named `customObject-{objectTypeId}`
];
export const bookmarkValues = homepageValues.concat(['campaigns', 'marketingEvents', 'forms', 'ctas', 'ctas-beta', 'leadScoring', 'landing-pages', 'landing-pages-beta', 'blog', 'blog-beta', 'podcasts-beta', 'casestudy-beta', 'knowledge-base', 'customer-portal', 'seo', 'payments-v5', 'invoices', 'payment-links', 'quotes', 'sales-products', 'subscriptions-uindex', 'chatflows', 'surveys', 'reports-list-v5-ia', 'marketing-collection-reports-list', 'sales-reports-list', 'service-reports-list', 'forecasting', 'goals-app', 'integrations', 'customEvents', 'datasets', 'dataModel', 'templates', 'meetings-v5', 'files', 'documents', 'playbooks', 'snippets', 'coaching-playlists']);
export const isHomePageAttribute = attribute => attribute.personaAttributeKey.personaAttributeName === 'homepage';
export const isBookmarksAttribute = attribute => attribute.personaAttributeKey.personaAttributeName === 'global-nav-bookmarked-items';